module.exports = __webpack_public_path__ + "static/media/upload.8db20e23.svg";